/* Display active tab content */
function filterSelection(c) {
  var x, i;
  x = document.getElementsByClassName("tabs-content--block");
  if (c == "all") c = "";
  for (i = 0; i < x.length; i++) {
    w3RemoveClass(x[i], "show");
    if (x[i].className.indexOf(c) > -1) w3AddClass(x[i], "show");
  }
  $(".tabs-filter--root .tabs-content--wrapper").fadeIn("slow");
  console.log('showing');
  $('#tab-pagina').twbsPagination('destroy');
  buildPagination();
}

function w3AddClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {element.className += " " + arr2[i];}
  }
}

function w3RemoveClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    while (arr1.indexOf(arr2[i]) > -1) {
      arr1.splice(arr1.indexOf(arr2[i]), 1);     
    }
  }
  element.className = arr1.join(" ");
}

// Add active class to the current button (highlight it)
var btnContainer = document.getElementById("myBtnContainer");
var btns = btnContainer.getElementsByClassName("btn");
for (var i = 0; i < btns.length; i++) {
  btns[i].addEventListener("click", function(){
    var current = document.getElementsByClassName("active");
    current[0].className = current[0].className.replace(" active", "");
    this.className += " active";
  });
}

/* Display pagination */
buildPagination();
function buildPagination(){
    var divCount = $('.tabs-filter--root .tabs-content--wrapper .tabs-content--block.show').length;
    console.log(divCount);
    var pagecount = Math.ceil($('.tabs-filter--root .tabs-content--wrapper .tabs-content--block.show').length/6);
    $('#tab-pagina').twbsPagination({
        totalPages: pagecount,
        visiblePages: 4,
        next: 'Next <img src="https://cdn.shopify.com/s/files/1/0651/0945/9203/files/arrow-right.svg"/>',
        prev: '<img src="https://cdn.shopify.com/s/files/1/0651/0945/9203/files/arrow-left.svg"/> Previous',
        first: '',
        last: '',
        onPageClick: function (event, page) {
          console.log('reinitialized');
          $(".tabs-filter--root .tabs-content--wrapper .tabs-content--block").removeClass("active");
          var x = document.querySelectorAll(".tabs-filter--root .tabs-content--wrapper .tabs-content--block.show");
          for (var i = (page-1)*6, len = x.length; i < ((page-1)*6+6); i++) {
              if(i < len){
                  x[i].classList.add("active");
              }
          }
       }
    }); 
    if(divCount<=6){
      $('.tab-pagina-container').css('border', 'none');
      $('#tab-pagina').twbsPagination('destroy');
    }
}